import '../assets/styles/BotaoZap.css';
import imgZap from '../assets/images/zap-icon.png';

export default function BotaoZap({texto}) {
  return (
    <a
      href="https://wa.me/554896644407"
      target="_blank"
      rel="noopener noreferrer"
      className="botao-zap"
    >
    {texto ?
        <span>{texto}</span>
        : 
        <img src={imgZap} alt="WhatsApp" />
    }
    </a>
  );
}
